import styled from "@emotion/styled"
import { Container } from "@mui/material"
import Navigation from "./Navigation"
import { default as Logo }  from './Icons/logo.svg'

const HeaderContainer = styled(Container)`
    &&& {
        display: flex;
        line-height: 2.5;
        justify-content: space-between; 
        align-items: center;
        padding: 10px;
        margin-top: 10px;
    }
`

const HoverLogo = styled.img`
    &&&:hover {
        transition: filter 200ms;
        filter: drop-shadow(0 0 0.25rem black);
    }
`

const Header: React.FC = () => {

    return (
        <HeaderContainer>
            <a href="/">
                <HoverLogo src={Logo} height={60} width={60} alt="test"/>
            </a>
            <Navigation />
        </HeaderContainer>
    )
}

export default Header